import { FilterTypes } from './form/filter-set-form.constants';
// If 'filters' has a value then 'rawFilter' needs to be 'null
// If 'rawFilter' has a value then 'filters' needs to be 'null'
export const formatFilterSet = (data, filterType) => {
    const formattedData = Object.assign({}, (filterType === FilterTypes.Filter ? Object.assign(Object.assign({}, data), { rawFilter: null }) : Object.assign(Object.assign({}, data), { filters: null })));
    return formattedData;
};
